import { AddonWidget } from 'addon-widget';
import {
    isGreetingsEnabled,
    getGreetingsProviderCode,
    getGreetingsProviderToken,
    getGreetingsPublicCdnUrl
} from '../app/bootstrap';


const initAddonWidget = async () => {
    try {
        const greetingsProviderCode = getGreetingsProviderCode();
        const providerToken = getGreetingsProviderToken();
        const publicCdnUrl = getGreetingsPublicCdnUrl();

        if (!isGreetingsEnabled()) {
            console.info('Greetings not enabled or missing required config for this brand');
            return;
        }

        if (!greetingsProviderCode || !providerToken || !publicCdnUrl) {
            console.info('Missing required config for initializing AddonWidget');
            return;
        }

        
        const greetingsConfigMap = {
            AMG: {
                greetingsProviderCode,
                publicCdnUrl,
                partnerKey: providerToken
            }
        };

        if (!greetingsConfigMap[greetingsProviderCode]) {
            console.info(`Unsupported greetings type: ${greetingsProviderCode}`);
            return;
        }
        const greetingsWidget = AddonWidget.create(greetingsProviderCode, greetingsConfigMap[greetingsProviderCode]);
        await greetingsWidget.init();
        window.addonWidget = greetingsWidget;
        console.log('AddonWidget initialized successfully');
    } catch (error) {
        console.error('Failed to initialize AddonWidget:', error);
    }
};

export { initAddonWidget };
